var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goTo",class:{
    hidden: _vm.scrollTop == 0,
    footerSpace: _vm.isAtBottom,
  },on:{"click":_vm.scrollToTop}},[_c('img',{staticClass:"goTo__image",attrs:{"loading":"lazy","src":_vm.requireAsset('icons/dropdown.svg'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }